// extracted by css-extract-rspack-plugin
export default {"root":"uVvUhrVhNlEvp60R","actions":"aik27puyBHYKd_Z3"};